export default __webpack_public_path__ + "static/animation2b-ffdcea0b618b72705c71d770b2f25bdc.mp4";